var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProtectionOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3523_168374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4131 4.74967C6.88366 5.55717 4.19947 5.93842 2.03766 6.02192C1.37647 6.04748 0.85391 6.58942 0.855472 7.25085C0.864535 11.155 1.70822 15.1124 3.31616 18.6693C5.75778 24.0704 10.2945 28.3359 15.5998 30.9051C16.1007 31.1477 16.686 31.1404 17.184 30.8919C22.5182 28.2299 26.9298 24.2602 29.4573 18.6693C31.064 15.1152 31.9076 11.1614 31.918 7.26023C31.9198 6.59704 31.3984 6.04754 30.7355 6.02192C26.0977 5.84273 20.6625 4.69448 17.2839 1.28085C16.7954 0.787292 15.997 0.799355 15.5133 1.29773C14.3616 2.4846 12.8325 3.40829 11.1527 4.11204",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6806 23.9162C25.3827 22.1327 26.7424 20.1229 27.7487 17.8969C29.0739 14.9657 29.8479 11.7336 30.0107 8.47924C30.0276 8.14193 29.7702 7.85206 29.4334 7.82787C22.9782 7.36424 19.0882 5.32418 16.8104 3.39399C16.579 3.19793 16.2399 3.19893 16.0076 3.39393C12.7042 6.16812 7.59031 7.48018 3.33437 7.82237C2.99981 7.84924 2.74581 8.13799 2.7625 8.47318C2.92462 11.7295 3.69875 14.9637 5.02468 17.8969C7.14512 22.5874 11.0668 26.5389 16.091 29.0569C16.2693 29.1463 16.4798 29.1481 16.6572 29.0571C18.8079 27.9542 20.7049 26.6686 22.3425 25.2082",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8281 14.7976H23.2337C23.959 14.7976 24.5469 15.3855 24.5469 16.1108V16.111C24.5469 16.8362 23.959 17.4242 23.2337 17.4242H22.8281",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83209 17.4242H9.55147C8.82622 17.4242 8.23828 16.8362 8.23828 16.111V16.1108C8.23828 15.3855 8.82622 14.7976 9.55147 14.7976H9.83209",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7468 14.4598C22.7477 6.66712 10.043 6.67999 10.043 14.4598C10.043 14.4598 10.043 15.8865 10.043 17.4049C10.043 25.0752 22.7431 25.0626 22.7423 17.4049C22.7422 16.4196 22.7468 14.4598 22.7468 14.4598Z",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0488 15.5347C14.3282 14.8143 13.162 14.8143 12.4414 15.5347",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3418 15.5347C19.6212 14.8143 18.455 14.8143 17.7344 15.5347",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4219 18.4998C14.9001 20.4161 17.8811 20.4161 18.3593 18.4998",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3008 8.62039C16.3008 8.62039 16.3102 7.84457 16.9268 7.47095",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3523_168374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.386719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtectionOutlinedWhite);
export default __webpack_public_path__ + "static/media/icon_protection_outlined_white.f12865b276c2b3c3aef4c5db3da0616d.svg";
export { ForwardRef as ReactComponent };